import { AuthorizationParams } from '@auth0/auth0-react'
import React, { useEffect } from 'react'

import useSessionLogger from '@scentregroup/shared/hooks/use-session-logger'

import SpinnerDelayed from '../../components/spinner-delayed'
import useLoginRedirect from '../../lib/use-login-redirect'

type Props = {
  isSignup?: boolean
  isMigrate?: boolean
  authorizationParams?: AuthorizationParams
}

const LoginRedirect: React.FC<React.PropsWithChildren<Props>> = ({
  isSignup = false,
  isMigrate = false,
  authorizationParams,
}) => {
  useSessionLogger()
  const loginRedirect = useLoginRedirect()
  const screenHintFlag = isSignup ? { screen_hint: 'signup' } : undefined
  const migrateFlag = isMigrate ? { context: 'migrate' } : undefined

  useEffect(() => {
    loginRedirect({
      ...screenHintFlag,
      ...migrateFlag,
      ...authorizationParams,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <SpinnerDelayed />
}

export default LoginRedirect
